import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Navbar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

const NavBarComponent = (props) => {
  return (
    <Fragment>
      <Navbar id="navbar-jack" fixed="top">
        <Navbar.Brand href="/">
          <img className="nav-icon-menu" src="/assets/fuentes/iconos/LogoJack.svg" alt="" />
        </Navbar.Brand>

        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Navbar.Text
            id="text-lang"
            className="logo-español"
            onClick={() => props.cambiarIdioma()}
          >
            {navigator.language || navigator.userLanguage === "es-MX"
              ? "ESP"
              : "ENG"}
          </Navbar.Text>
          <div className="contendeor-burger">
            <div id="content-burger">
              <Navbar.Text
                onClick={() =>
                  props.statusMenu
                    ? props.closeNav()
                    : props.openNav()
                }
              >
                {props.statusMenu ? (
                  <Fragment>
                    <img src="/assets/fuentes/iconos/Cerrar.svg" alt="" />
                  </Fragment>
                ) : (
                    <Fragment> &#9776;</Fragment>
                  )}
              </Navbar.Text>
            </div>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </Fragment>
  );
};

NavBarComponent.propTypes = {
  cambiarIdioma: PropTypes.func,
  statusMenu: PropTypes.bool,
  closeNav: PropTypes.func,
  openNav: PropTypes.func,
};

export default NavBarComponent;
